export default __webpack_public_path__ + "static/media/3923.c9386bc0.png";